import React from 'react';
import Timeline from './Timeline'; // Import the reusable Timeline component
// Remove WorkExperience.css import if all styles moved to Timeline.css or App.css
// import './WorkExperience.css';

const workExperienceData = [
  {
    company: "Steinberg Media Technologies GmbH",
    title: "C++ Developer",
    subtitle: "Steinberg Media Technologies GmbH",
    duration: "Full-time: 07/2025 - Present",
    details: [
        "Cross-platform application development for Windows and macOS using C++.",
        "Building and maintaining user interfaces with the Qt framework.",
        "Focused on creating robust and efficient software solutions."
    ],
    technologies: ["C++", "Qt"]
  },
  {
    company: "GNS mbH",
    title: "C++ Developer in AI/ML",
    subtitle: "GNS mbH", // Use subtitle for company name
    duration: "Full-time: 10/2023 - 06/2025",
    details: [
      "Application development in C++ (Qt, Boost)",
      "AI Development: Deep Learning and Machine Learning (PyTorch, PyTorch3D)"
    ],
    technologies: ["C++", "Python", "PyTorch", "Qt"] // Added technologies
  },
  {
    company: "Sekai Europe GmbH",
    title: "Software Engineer",
    subtitle: "Sekai Europe GmbH", // Use subtitle for company name
    duration: "Multiple Roles: 08/2017 - 10/2023",
    durationDetails: [ // Add detailed breakdown here
        "Part-time from 02/2023 - 10/2023",
        "Working Student from 04/2021 - 04/2023",
        "(between Bachelor and Master) Full-Time from 10/2020 - 04/2021",
        "Working Student from 08/2017 - 10/2020"
    ],
    details: [
      "Development of eWindow® 360 software in C++",
      "Hardware-accelerated algorithms (CUDA)",
      "Computer Vision (OpenCV)",
      "Camera Control (V4L2)",
      "Real-time video processing (FFMPEG, GStreamer)",
      "GUI and 3D Graphics (Qt, OpenGL)",
      "Python tools and automation"
    ],
    technologies: ["C++", "Python", "CUDA", "OpenCV", "Qt", "OpenGL"] // Added technologies
  }
  // Add more job experiences here if needed
];

// Map company to subtitle for the Timeline component
const timelineItems = workExperienceData.map(job => ({
    ...job,
    subtitle: job.company // Map company to subtitle
}));


const WorkExperience = ({ id }) => {
  // Remove useState, useEffect, useRef, and the scroll handling logic
  // const [scrollProgress, setScrollProgress] = useState(0);
  // const timelineRef = useRef(null);
  // useEffect(() => { ... });

  return (
    // Pass data, title, position, and id to the Timeline component
    <Timeline
      id={id}
      items={timelineItems}
      title="Work Experience"
      position="left" // Explicitly set position or rely on default
    />
    // Remove the old section structure
    /*
    <section className="work-experience-section" ref={timelineRef}>
      <h2>Work Experience</h2>
      <div className="timeline-container">
        ... old timeline rendering ...
      </div>
    </section>
    */
  );
};

export default WorkExperience;
